import { styled } from '@mui/material';

export const ConfirmationItemWrapper = styled('div')({
  fontSize: 14,
});
